import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import JsonLd from "@/components/base/JsonLd";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import CourseHero from "./components/CourseHero";
import CourseIncludes from "./components/CourseIncludes";
import CourseForWho from "./components/CourseForWho";
import EnrollmentForm from "./components/EnrollmentForm";
import CourseFAQ from "./components/CourseFAQ";
import AboutGleice from "./components/AboutGleice";
import NaMidia from "./components/NaMidia";

const modules = [
  { number: "01", title: "Introdução da Clientizah" },
  { number: "02", title: "Introdução ao Curso" },
  { number: "03", title: "O que é ser vendedora?" },
  { number: "04", title: "Orgulho de ser vendedora" },
  { number: "05", title: "Mentalidade vendedora CAT" },
  { number: "06", title: "Metas CAT — KPIs, dados e métricas" },
  { number: "07", title: "Dress code — Vendedora CAT" },
  { number: "08", title: "Técnicas e dicas de vendas" },
  { number: "09", title: "Neuro vendas & Neurociência" },
  { number: "10", title: "Storytelling & Conhecimento" },
  { number: "11", title: "Apresentação Pessoal" },
  { number: "12", title: "Como fazer um Currículo e ir bem em qualquer entrevista" },
  { number: "13", title: "Conhecimento e aprendizado CAT" },
  { number: "14", title: "Método de atendimento CAT" },
  { number: "15", title: "VM de loja CAT" },
  { number: "16", title: "Estoque rentável" },
  { number: "17", title: "Construção de networking e aumento das vendas" },
  { number: "18", title: "WhatsApp Business & CRM" },
  { number: "19", title: "Ferramentas de IA para o dia a dia da loja & Mídias virais" },
  { number: "20", title: "Venda com TikTok e TikTok Shop" },
];

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Course",
  name: "Método C.A.T — Vendedora",
  description:
    "Desenvolvida para quem vive o chão de loja todos os dias. Técnicas reais de vendas, comportamento do consumidor e ferramentas digitais como IA para você vender mais, encantar mais e se destacar de forma consistente.",
  provider: {
    "@type": "Organization",
    name: "Clientizah",
  },
  instructor: {
    "@type": "Person",
    name: "Gleice Lyra",
    jobTitle: "Especialista em Varejo e Vendas",
  },
  timeRequired: "PT30H",
  educationalLevel: "Beginner",
  inLanguage: "pt-BR",
  offers: {
    "@type": "Offer",
    price: "498.50",
    priceCurrency: "BRL",
    availability: "https://schema.org/LimitedAvailability",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "12000",
    bestRating: "5",
  },
};

export default function InscricaoVendedora() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
      }
    }
  }, [location.hash]);

  return (
    <div className="relative min-h-screen bg-white">
      <title>Método C.A.T Vendedora | Curso de Vendas no Varejo | Clientizah</title>
      <meta name="description" content="Curso completo para vendedoras que querem dominar técnicas de atendimento, neurovendas, WhatsApp Business, TikTok Shop e IA. Método C.A.T da Clientizah com Gleice Lyra." />
      <meta name="keywords" content="curso vendedora, Método CAT, vendas varejo, neurovendas, WhatsApp Business, TikTok Shop, Gleice Lyra, Clientizah, curso vendas online" />
      <link rel="canonical" href={`${(import.meta.env.VITE_SITE_URL as string) || ""}/inscricao`} />
      <JsonLd data={jsonLd} />
      <Navbar />
      <main className="pt-[160px]">
        <CourseHero
          badge="Vagas Limitadas"
          title="Método C.A.T"
          subtitle="Vendedora"
          tagline="Cliente · Atenção · Todo tempo"
          description="Desenvolvida para quem vive o chão de loja todos os dias — do atendimento ao fechamento. Técnicas reais de vendas, comportamento do consumidor e ferramentas digitais como IA para você vender mais, encantar mais e se destacar de forma consistente. Tenha uma carteira de clientes recorrentes."
          hours="+30 horas de conteúdo"
          bgSeq="coursehero-vendedora"
        />
        <CourseIncludes modules={modules} totalHours="30" />

        <CourseForWho
          forWho={[
            {
              icon: "ri-seedling-line",
              title: "Vendedoras que estão começando agora",
              desc: "Quer entrar no varejo com o pé direito, aprender do zero com método e já sair aplicando no primeiro dia de trabalho.",
            },
            {
              icon: "ri-arrow-up-circle-line",
              title: "Vendedoras experientes que querem se reposicionar",
              desc: "Já tem prática, mas sente que trava na abordagem, no fechamento ou na fidelização. Quer técnica, consistência e resultados maiores.",
            },
            {
              icon: "ri-smartphone-line",
              title: "Quem quer dominar o digital no varejo",
              desc: "Quer usar o WhatsApp Business, TikTok Shop e ferramentas de IA para vender mais sem depender só do fluxo da loja.",
            },
            {
              icon: "ri-medal-line",
              title: "Quem quer se destacar e crescer na carreira",
              desc: "Busca reconhecimento, promoção ou quer montar seu próprio negócio — e entende que método é o caminho mais curto.",
            },
          ]}
          notForWho={[
            "Busca resultados sem se dedicar ao aprendizado e à aplicação prática.",
            "Precisa vender algum produto.",
            "Espera uma fórmula sem precisar mudar nenhum hábito, somente incluir os estudos e práticas.",
          ]}
        />

        <AboutGleice />
        <NaMidia />

        <div id="inscricao">
          <EnrollmentForm defaultCourseKey="vendedora" />
        </div>
        <CourseFAQ />
      </main>
      <Footer />
    </div>
  );
}
